import { render } from "./AboutThisEvent.vue?vue&type=template&id=752f6194&ts=true"
import script from "./AboutThisEvent.vue?vue&type=script&lang=ts"
export * from "./AboutThisEvent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__